import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthRedirect',
  setup(__props) {

onMounted(async () => {
  console.log("coming in");
  //window.close();
});

const CloseHubLogin = ()=>{
  window.opener.postMessage('closeWindow', 'http://localhost:8082');
  window.close();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", null, "auto redirect page", -1)),
    _createElementVNode("div", { onClick: CloseHubLogin }, "关闭窗口")
  ], 64))
}
}

})